export default __webpack_public_path__ + "static/media/new-external-tab-image.9ae6d8ec.svg";